import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { UserActions, userFeature } from '@state';
import { PhoneNumberPipe, MsisdnPipe, TranslatePipe } from '@core/pipes';
import { ClickToCopyDirective } from '@core/directives';
import { Router } from '@angular/router';
import { AppRouting } from '@core/enums';
import { MsisdnInfo } from '@core/contracts/data-contracts';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sc-msisdn-radio-button-list',
  imports: [PhoneNumberPipe, ClickToCopyDirective, MsisdnPipe, TranslatePipe, AsyncPipe],
  templateUrl: './msisdn-radio-button-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MsisdnRadioButtonListComponent {
  @ViewChildren('msisdnItem') msisdnItems!: QueryList<ElementRef<HTMLElement>>;

  @Output() readonly msisdnSelected = new EventEmitter<void>();

  public scrollToSelectedMsisdn() {
    const msisdns = this.msisdnList();
    const selectedId = this.currentCustomerId();
    const index = msisdns.findIndex((m) => m.customerId === selectedId);
    const item = this.msisdnItems?.get(index);
    item?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  public msisdnList = this.store.selectSignal(userFeature.selectMsisdns);
  public currentCustomerId = this.store.selectSignal(userFeature.selectCustomerId);

  constructor(
    private readonly store: Store,
    private readonly router: Router
  ) {}

  public selectMsisdn(msisdn: MsisdnInfo) {
    this.store.dispatch(UserActions.changeCurrentMsisdn(msisdn.customerId));
    this.router.navigate([`/${AppRouting.Overview}`]);
    this.msisdnSelected.emit();
  }
}
